import * as React from 'react'
import {useEffect} from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../lib/MobXProvider'
import {WidgetApi} from '../../../lib/WidgetApi'
import {IconSpinner} from '../../ui/Icons'

///////////////////////////////////////////////////////////////////////////////

export const SpinnerInnerBlock = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const spinnerText = api.trans('spinner_loading', {defaultValue: null})

  useEffect(() => {
    setTimeout(async () => {
      await api.ui.scrollToTop()
    })
  }, [])

  return (
    <div className="spinner-inner-block">
      {spinnerText && (
        <span className="sr-only" role="status" aria-live="assertive">
          {spinnerText}
        </span>
      )}
      <IconSpinner />
    </div>
  )
})
